export default __webpack_public_path__ + "static/media/480_business03-en-web.b2738a43.png";